/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('netsuiteSourceEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./netsuite-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.bodyDataOptions = {
            lineWrapping: true,
            lineNumbers: true,
          };
        },
      ],
    };
  },
]);
